import { z } from "zod";

export const openCustomerInstructionSchema = z.object({
  header: z.string().min(1, "Headline is required"),
  main: z.string().min(1, "Content is required"),
});

export type OpenCustomerInstructionData = z.infer<
  typeof openCustomerInstructionSchema
>;
